<template>
    <div :class="{ 'on-wait-cursor': onLoadExports}">
      <div :class="{ 'disabled-diiv': onLoadExports}"
        style="box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; overflow: hidden; border-radius: 8px; margin-top: 12px; background-color: white;">
              <div style="padding: 22px 24px;">
                <div style="display: flex; justify-content: space-between;">
                 <h3> {{ $t('Recently Exported') }}</h3>
                    <button class="txt-btn" style="margin-top: 18px;" @click="clearFilters()">
                        <h5>{{ $t('Clear Filters') }}</h5>
                    </button>
                </div>
                 <div style="display: flex;">
                    <div class="rep-search" style="margin-right: 12px; width: 40%;">
                        <p style="margin-bottom: 0px; font-weight: 500;">{{ $t('Search report') }}</p>
                        <prozess-input
                            v-model="filters.reportSearch"
                            style="width: 100%; margin-top: 0px; padding-top: 0px;"/>
                    </div>
                    <div style="margin-right: 12px; width: 50%; max-width: 15vw;">
                        <p style="margin-bottom: 0px; font-weight: 500;">{{ $t('Status') }}</p>
                        <b-dropdown size="md" variant="outline-primary" style="width: 100%;">
                            <template #button-content>
                                <span class="text-nowrap">{{ $t(getStatusLabel(filters.status)) }}</span>
                            </template>
                            <b-dropdown-text style="width: 200px">{{ $t('Select Report Module') }}</b-dropdown-text>
                            <b-dropdown-item :key='allll'
                                @click="setReportStatus('');">
                                {{ $t('All') }}
                            </b-dropdown-item>
                            <b-dropdown-item v-for="reportStatus in statuses" :key="reportStatus.key"
                                @click="setReportStatus(reportStatus.key);">
                                {{ reportStatus.label }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>

                    <div class="d-range" style="margin-right: 12px;">
                        <p style="margin-bottom: 0px; font-weight: 500;">{{ $t('Date Range') }}</p>
                        <div class="d-flex" style="margin-right: 12px;">
                            <b-dropdown size="md" variant="outline-primary" style="width: 140px; height: 32px; margin-right:6px;">
                                <template #button-content>
                                    <span class="text-nowrap">{{filters.periodType == 'custom' ? "Custom Date": filters.yearFilter != null ? filters.yearFilter : $t('Period') }}
                                    </span>
                                </template>
                                <b-dropdown-text style="width: 200px">{{ $t('Select Year or Date Range') }}</b-dropdown-text>
                                <b-dropdown-item :key="custom" @click="setCustomDateFilter();">
                                    {{ $t('Custom Date') }}
                                </b-dropdown-item>
                                <b-dropdown-item
                                    v-for="year in years"
                                    :key="year.name"
                                    @click="setCustomYearFilter(year.name);"
                                >
                                    {{ year.name }}
                                </b-dropdown-item>
                            </b-dropdown>
                            <div  style="height: 32px;" :class="{
                            'div-disabled': !isCustomDateFilter()
                            }">
                                <date-range-filter
                                    ref="dateRangeFilter"
                                    style="width: 200px; margin: 0px; margin-top: -10px;"
                                    @applyDateFilter="applyDateFilter"
                                />
                            </div>
                        </div>
                    </div>
                 </div>
            </div>

            <div class="custom-tabl">
                <div style="position: relative; padding: 12px 24px; border-top: solid 1px gainsboro; border-bottom: solid 1px gainsboro; background-color: rgb(249, 251, 252); display: flex;">
                    <h4 class="header-txt" style="width: 60%;">{{ $t('FILE NAME') }}</h4>
                    <h4 class="header-txt" style="width: 30%;">{{ $t('GENERATED BY') }}</h4>
                    <h4 class="header-txt" style="width: 25%;">{{ $t('INITIATED') }}</h4>
                    <h4 class="header-txt" style="width: 25%;">{{ $t('STATUS') }}</h4>
                    <h4 class="header-txt" style="width: 40%;">{{ $t('ACTIONS') }}</h4>
                    <button @click="getExports" class="txt-btn refresh-btn"  style=" position: absolute; right: 0; align-items: center; justify-content: center; display: flex; padding: 6px;" >
                        <feather-icon icon="RefreshCcwIcon" size="18"/>
                    </button>
                </div>
                    <div>
                        <div v-if="onLoadExports"
                            class="d-flex justify-content-center align-items-center"
                            style="height: 100px" >
                            <b-spinner class="align-middle" />
                        </div>
                        <div v-else v-for="report in getReportItems()" :key="report.id" style="border-bottom: 1px gainsboro solid;  padding-left: 24px; padding-right: 24px;">
                           <div style="display: flex; padding-top: 6px; padding-bottom: 6px;">
                            <!-- <p>{{ JSON.stringify(report) }}</p> -->
                                <div class="col-block col-block-1" style="width: 60%;">
                                    <p class="row-txt" style="font-size: 1.1rem; font-weight: 600; margin-bottom: 0px;">{{ report.fileName }}</p>
                                    <div style="display: flex; margin-top: 2px;">
                                         <p :class="{
                                                'module-idd': report.moduleKey === 'idd'
                                                ,'module-sales': report.moduleKey === 'sales'
                                                }"
                                                class="row-txt namesub-label report-temp-name" style="font-size: 0.9rem; opacity: 0.8;">{{ report.reportTemplateName }}</p>
                                        <p :class="{
                                                'module-idd': report.moduleKey === 'idd'
                                                ,'module-sales': report.moduleKey === 'sales'
                                                }"
                                                class="row-txt namesub-label" style="margin-left: 4px; font-size: 0.9rem; opacity: 0.8;">{{ $t(getReportModuleLabel(report.moduleKey)) }}</p>

                                    </div>
                                </div>
                                <div class="col-block col-block-3" style="width: 30%;">
                                    <!-- <p class="row-txt">{{ report.userId }}</p> -->
                                    <p class="row-txt">{{ report.initiatorName }}</p>
                                </div>
                                 <div  class="col-block col-block-4" style="width: 25%;">
                                    <p class="row-txt">{{ report.initiatedDate }}</p>
                                </div>
                                <div class="col-block col-block-5" style="width: 25%;">
                                    <p class="status-txt"
                                        v-if="report.status != null && report.status !== ''"
                                       :class="{
                                        'status-complete': report.status === 'COMPLETED'
                                        ,'status-processing': report.status === 'PROCESSING' || report.status === 'EXECUTING'
                                        ,'status-failed': (report.status === 'FAILED' || report.status === 'UNKNOWN')
                                        }"
                                        >{{ $t(getStatusLabel(report.status)) }}</p>
                                </div>
                                <div class="col-block col-block-6" style="width: 40%;">
                                    <button class="txt-btn" style="width: 100px;" @click="dowloadFile(report.id, report.fileName)">
                                        <h5 style="color:rgb(81, 173, 123); font-weight: 700; text-align: left;">{{ $t('Download') }}</h5>
                                    </button>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
            <div style="display: flex; justify-content: space-between; padding-top: 10px; background-color: rgb(250,250,249);">
                <div style="padding-left: 20px;">
                    <p class="text-muted">
                        <span class="text-muted">{{ $t('Showing') }} {{ pagi.from }} {{ $t('to') }} {{ pagi.to }} {{ $t('of') }} {{ pagi.of }} {{ $t('entries') }}</span>
                    </p>
                </div>
                <div style="padding:10px; margin-top: -10px;">
                    <div style="display: flex; position: relative;">
                        <div style="position: absolute; left: 10px;  background-color: rgb(243, 243, 243); height: 30px; width: 10px; margin-left: 10px;">

                        </div>
                        <div style="position: absolute; z-index: 0; right: 20px;background-color: rgb(243, 243, 243); height: 30px; width: 10px; margin-left: 10px;">

                        </div>
                        <button class="pagi-btn" style="z-index: 2;">
                            <feather-icon
                                icon="ChevronLeftIcon"
                                size="18"
                            />
                        </button>
                        <button class="pagi-n-btn" v-for="n in getPaginationPages()" :key="n" :class="{ 'pagi-no-t': n==='...'}" @click="setPage(n)">
                            <p class="pagi-n" style="margin: 0px">{{ n }}</p>
                        </button>
                        <button class="pagi-btn" style="z-index: 2;">
                            <feather-icon
                                icon="ChevronRightIcon"
                                size="18"
                                />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import reportService from '@/services/report'
import reportDashboardService from '@/services/reportDashboard'
import DateRangeFilter from '@/components/Lists/DateRangeFilter.vue'
import moment from 'moment'
import { downloadFromURL } from '@/helpers/app'

export default {
    components: {
        DateRangeFilter,
    },
    data() {
        return {
            onLoadExports: true,
            exportItems: [],
            filters: this.getDefaultFilter(),
            currentPage: 1,
            pollTimer: null,
            torndown: false,
            pagi: {
                from: 0,
                to: 0,
                of: 0,
            },
            modules: [
                { key: 'idd', label: 'IDD Compliance' },
                { key: 'sales', label: 'Sales' },
            ],
            statuses: [
                { key: 'COMPLETED', label: 'Completed' },
                // { key: 'PROCESSING', label: 'Processing' },
                { key: 'FAILED', label: 'Failed' },
            ],
            years: Array.from({ length: new Date().getFullYear() - 2022 }, (_, i) => new Date().getFullYear() - i).map(year => ({
                name: year,
            })),
        }
    },
    async mounted() {
        this.setCustomYearFilter(new Date().getFullYear())
        await this.getExports()

        /*
         * mounted() is async, so everything below the await runs after the first load returns.
         * Leave the page while that request is still in flight and beforeDestroy() has already
         * run — with pollTimer still null, so it clears nothing — and the interval started here
         * lands on a destroyed component that nothing will ever stop. It then polls
         * /api/report/generated every 7s for the life of the page, and every visit cut short
         * that way adds another one. The slower the endpoint, the wider the window.
         */
        if (this.torndown) {
            return
        }

        // Silently refresh so newly generated reports appear and PROCESSING rows flip to COMPLETED
        // without a manual refresh.
        this.pollTimer = setInterval(() => this.getExports(true), 7000)
    },
    beforeDestroy() {
        this.torndown = true
        if (this.pollTimer) {
            clearInterval(this.pollTimer)
            this.pollTimer = null
        }
    },
  methods: {
       async dowloadFile(id, fileName) {
             console.log('getOneExportFile id', id)
             console.log('getOneExportFile fileName', fileName)
             const resss = await reportDashboardService.getOneExportFile(id)
             console.log('response?.data?.url', resss.data?.url)
             downloadFromURL(resss.data?.url, fileName)
       },
       getPaginationPages() {
            const totalPages = Math.ceil(this.pagi.of / 20)
            const maxVisible = 7
            if (totalPages < 1) return []

            const pages = []
            const middleCount = maxVisible - 2 // Reserve 1 for start, 1 for end

            pages.push(1)

            if (totalPages === 1) return pages
            pages.push('...')
            let start = Math.max(2, this.currentPage - Math.floor(middleCount / 2))
            let end = start + middleCount - 1

            if (end >= totalPages) {
                end = totalPages - 1
                start = Math.max(2, end - middleCount + 1)
            }

            for (let i = start; i <= end; i++) {
                pages.push(i)
            }

            // Ellipsis before last page
            if (end < totalPages - 1) {
                pages.push('...')
            }

            // Always include last page
            pages.push(totalPages)

            return pages
        },
        setPage(p) {
            const itemPerPage = 20
            this.currentPage = p
            const pagi = {
                from: 1 + ((this.currentPage - 1) * itemPerPage),
                to: ((this.currentPage - 1) * itemPerPage) + itemPerPage,
                of: this.exportItems.length,
            }
            this.pagi = pagi
        },
        async getExports(silent = false) {
            if (!silent) {
                this.onLoadExports = true
            }
            try {
                const genRes = await reportService.getGeneratedList()
                this.exportItems = []
                genRes.data.forEach(element => {
                    const exportItem = { ...element }
                    if (this.$i18n.locale === 'no') {
                        moment.locale('nb')
                    } else {
                        moment.locale('en')
                    }
                    exportItem.initiatedDate = moment(new Date(element.jobStarted)).fromNow()
                    this.exportItems.push(exportItem)
                })
                // Keep the user on their current page during background polling; reset to page 1 only
                // on an explicit/initial load.
                this.setPage(silent ? this.currentPage : 1)
            } finally {
                if (!silent) {
                    this.onLoadExports = false
                }
            }
        },
        getReportModuleLabel(moduleKey) {
            return this.modules.filter(m => m.key === moduleKey)[0]?.label
        },
        getDefaultFilter() {
                return {
                    moduleKey: '',
                    status: '',
                    reportSearch: '',
                    yearFilter: null,
                    periodType: null,
                    dateRange: [],
                }
        },
        setReportStatus(key) {
            this.filters.status = key
        },
        getReportItems() {
            let reportss = JSON.parse(JSON.stringify(this.exportItems))
            if (this.filters.moduleKey) {
                reportss = reportss.filter(r => r.module === this.filters.moduleKey)
            }
            if (this.filters.status) {
                reportss = reportss.filter(r => r.status === this.filters.status)
            }
            if (this.filters.reportSearch !== '') {
                reportss = reportss.filter(r => r.fileName.toUpperCase().replace(' ', '').includes(this.filters.reportSearch.toUpperCase().replace(' ', '')))
            }
            // pagi.from is 1-based (drives the "Showing X to Y" label); slice needs a 0-based start,
            // otherwise index 0 — the most recently generated report — is always dropped.
            reportss = reportss.slice(this.pagi.from - 1, this.pagi.to)
            return reportss
        },
        getStatusLabel(statusKey) {
            if (statusKey === '') {
                return 'All'
            }
            if (statusKey === 'PROCESSING' || statusKey === 'EXECUTING') {
                return 'Processing'
            }
            return this.statuses.filter(m => m.key === statusKey)[0]?.label
        },
        setCustomDateFilter() {
            if (this.filters.periodType !== 'custom') {
                this.filters.periodType = 'custom'
                this.filters.yearFilter = null
            }
        },
        async setCustomYearFilter(year) {
            this.filters.yearFilter = year
            this.filters.periodType = 'year'
            this.filters.dateRange = [`01-01-${year}`, `12-31-${year}`]
        },
        isCustomDateFilter() {
            return this.filters.periodType === 'custom'
        },
        async applyDateFilter(val) {
            this.filters.dateRange = val
        },
        clearFilters() {
            this.filters = JSON.parse(JSON.stringify(this.getDefaultFilter()))
        },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/company-contact-list.scss';

.div-disabled{
    pointer-events: none;
    opacity: 0.3;
}
.txt-btn {
    width: fit-content !important;
    margin-right: 10px;
    cursor: pointer;
    transition: 0.2s;
    opacity: 0.7;
    margin-bottom: 0px;
    border: none;
    background-color: transparent;
    outline: none;
    box-shadow: none;
}
.txt-btn:focus{
    outline: none;
    box-shadow: none;
}
.txt-btn:hover {
    opacity: 1;
}

.status-txt-2{
    background-color: gainsboro;
    padding: 0px 8px;
    border-radius: 20px;
    text-align: center;
    width: fit-content;
    font-size: 0.8rem;
    margin-bottom: 2px;
    margin-left: -4px;
}
.status-complete {
    background-color: rgb(219, 253, 234);
    color: rgb(22, 163, 75);
}
.status-processing {
    background-color: rgb(254, 249, 197);
    color:rgb(153, 127, 41);
}
.status-failed {
    background-color: rgb(254, 197, 197) !important;
    color:rgb(153, 41, 41);
}
.header-txt{
    width: 100%;
    color: darkgray;
    opacity: 0.7;
    font-size: 1rem;
}
.disabled-diiv{
    pointer-events: none;
    opacity: 0.8;
}
.on-wait-cursor{
    cursor:progress !important;
}
.refresh-btn{
    background-color: none ;
    width: 50px !important;
    margin-top: -6px;
}
.namesub-label {
    width: fit-content !important;
    padding: 0px 6px;
    height: fit-content !important;
    border-radius: 6px !important;
}
.report-temp-name{
    color: black !important;
    background-color: rgb(238, 238, 238) !important;
}
.pagi-btn{
    border: none;
    background-color: rgb(243, 243, 243);
    transition: 0.2s;
    padding:5px;
    border-radius: 20px;
    width: 30px;
    height: 30px;
}
.pagi-btn:hover{
    background-color: rgb(29, 153, 89)
}
.pagi-n-btn{
    border: none;
    background-color: rgb(243, 243, 243);
    transition: 0.2s;
    width: 40px;
    height: 30px;
    opacity: 0.8;
}
.pagi-n-btn:hover{
    opacity: 1;
}
.pagi-n{
   transition: 0.2s;
}
.pagi-n:hover{
   color:  rgb(29, 153, 89);
}
.pagi-no-t{
    pointer-events: none;
}

</style>
